import { z } from 'zod';

export const GenerateTokenSchema = z.object({
  token: z.string(),
});
export type GenerateTokenData = z.infer<typeof GenerateTokenSchema>;
